import { createFileRoute } from "@tanstack/react-router";
import { ContentPage } from "@/components/seo/content-page";
import { pickContent } from "@/assets/generated";
import { seoMeta } from "@/lib/seo/head";
import { legalServiceSchema } from "@/components/seo/json-ld";

export const Route = createFileRoute("/aree/diritto-tributario")({
  head: () => seoMeta({
    title: "AI per il diritto tributario",
    description: "Ricerca su norme fiscali, prassi e giurisprudenza tributaria; redazione di ricorsi alle Corti di Giustizia Tributaria.",
    path: "/aree/diritto-tributario",
  }),
  component: () => (
    <ContentPage
      extraSchemas={[legalServiceSchema({ name: "LexAIPro - AI per il diritto tributario", description: "Assistenza AI per ricorsi tributari, pareri fiscali e ricerca normativa.", path: "/aree/diritto-tributario" })]}
      eyebrow="Aree di pratica"
      title="LexAIPro per il diritto tributario"
      lead="Ricerca su TUIR, IVA, accertamento e contenzioso tributario; redazione di ricorsi e memorie. Aggiornato a normativa e prassi."
      breadcrumbs={[{name:"Home",path:"/"},{name:"Aree",path:"/aree/diritto-tributario"},{name:"Diritto tributario",path:"/aree/diritto-tributario"}]}
      sections={[
        { heading: "Casi d'uso", bullets: ["Ricorsi alle Corti di Giustizia Tributaria","Pareri fiscali","Analisi avvisi di accertamento","Ricerca su circolari Agenzia delle Entrate"] },
      ]}
      cta={{ label: "Prova gratis", to: "/signup" }}
      heroImage={pickContent(22)}
      updated="2026"
    />
  ),
});
